module.exports = __webpack_public_path__ + "media/bj.c4473419.mp3";